var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0928 2.5C16.32 2.5001 17.3145 3.49542 17.3145 4.72266V15.0928C17.3144 16.3199 16.3199 17.3144 15.0928 17.3145H4.72266C4.6991 17.3145 4.67572 17.3113 4.65234 17.3105C4.64683 17.31 4.64125 17.3102 4.63574 17.3096C3.44882 17.2639 2.5001 16.2908 2.5 15.0928V4.72266C2.5 3.49536 3.49536 2.5 4.72266 2.5H15.0928ZM6.51074 15.833H15.0918C15.5009 15.833 15.8329 15.5018 15.833 15.0928V12.4365L12.8691 9.47363L6.51074 15.833ZM4.72168 3.98145C4.31266 3.98154 3.98145 4.31362 3.98145 4.72266V15.0928C3.9815 15.4106 4.18275 15.6782 4.46387 15.7832L12.3467 7.90234C12.6119 7.63727 13.0281 7.61499 13.3184 7.83594L13.3936 7.90234L15.833 10.3408V4.72266C15.833 4.31356 15.5009 3.98145 15.0918 3.98145H4.72168ZM7.31445 5.46289C8.33705 5.46289 9.16675 6.29191 9.16699 7.31445C9.16699 8.3372 8.3372 9.16699 7.31445 9.16699C6.29191 9.16675 5.46289 8.33705 5.46289 7.31445C5.46314 6.29206 6.29206 5.46314 7.31445 5.46289ZM7.31543 6.94434C7.11109 6.94442 6.94456 7.11014 6.94434 7.31445C6.94434 7.51895 7.11095 7.68546 7.31543 7.68555C7.51983 7.68537 7.68555 7.51889 7.68555 7.31445C7.68533 7.1102 7.51969 6.94451 7.31543 6.94434Z",
    fill: "#77928B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.d142c18f655e9a99c09004f5702aa2c9.svg";
export { ForwardRef as ReactComponent };